var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxTrashAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0742 2.39453H8.57422C7.56314 2.39453 6.74089 3.21678 6.74089 4.22786V6.0612H3.07422V7.89453H4.90755V18.8945C4.90755 19.9056 5.7298 20.7279 6.74089 20.7279H15.9076C16.9186 20.7279 17.7409 19.9056 17.7409 18.8945V7.89453H19.5742V6.0612H15.9076V4.22786C15.9076 3.21678 15.0853 2.39453 14.0742 2.39453ZM8.57422 4.22786H14.0742V6.0612H8.57422V4.22786ZM15.9076 18.8945H6.74089V7.89453H15.9076V18.8945Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxTrashAlt);
export default __webpack_public_path__ + "static/media/bx-trash-alt.6c5c7136bdd954741f838b65970945d5.svg";
export { ForwardRef as ReactComponent };